// AB#2045 — TanStack Query mutation for the SuperAdmin "Grant founding access"
// action. Wraps POST /api/super-admin/businesses/{businessId}/grant-subscription
// (SuperAdminSubscriptionController; SuperAdmin-only, re-authorized server side).
// Follows the useCategoriesAdmin write-hook pattern: a useMutation that
// invalidates the affected query cache on success. Toast is handled by the
// caller (the modal), mirroring CreateCategoryModal.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    apiService,
    type GrantSubscriptionRequest,
    type GrantSubscriptionResponse,
} from '../services/api';
import { queryKeys } from '../lib/queryKeys';

export interface GrantSubscriptionVariables {
    businessId: number;
    payload?: GrantSubscriptionRequest;
}

/**
 * Grant a business a complimentary Trial subscription so it can be provisioned
 * as founding/free (lifting the 1-branch cap). Invalidates the subscription
 * cache on success so any subscription-derived views refetch.
 */
export function useAdminGrantSubscription() {
    const qc = useQueryClient();
    return useMutation<GrantSubscriptionResponse, Error, GrantSubscriptionVariables>({
        mutationFn: ({ businessId, payload }) =>
            apiService.grantSubscription(businessId, payload),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: queryKeys.subscription.all });
        },
    });
}
